// Validação de EANs para impressão detalhada
export function validateEanInputs(items_gtin = [], eanValidated = []) {
  let missingGtin = false;
  let missingValidation = false;
  items_gtin.forEach((item, idx) => {
    if (!item.gtin_code) missingGtin = true;
    if (item.gtin_code && !eanValidated[idx]) missingValidation = true;
  });
  return { missingGtin, missingValidation };
}

// Validação de impressora selecionada
export function validatePrinter(selectedPrinter, labelFormat) {
  if (labelFormat === 'zpl' && !selectedPrinter) return false;
  return true;
} 